import { makeStyles } from "@mui/styles";
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
    mainLobbyFilterContainer: {
        background: "rgba(0, 0, 0, 0.6)",
        "& .MuiDialog-paper": {
            padding: 0,
            margin: 0,
            width: "100%",
            maxWidth: 800,
            height: "auto",
            background: "rgba(0, 0, 0, 1)",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
                width: 0,
                height: 0,
                display: "none",
            },
        },
        "& .MuiPaper-root": {
            background: "rgba(245, 245, 245, 0.05)",
            backdropFilter: "blur(5px)",
            borderRadius: 16,
        },
    },

    modalContent: {
        padding: 24,
        color: "#fff",
        borderRadius: 8,
    },

    modalTitleBlock: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 15,
    },

    modalTitle: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 20,
        fontWeight: 400,
        color: "rgba(245, 245, 245, 1)",
        gap: 10,
    },

    createIcon: {
        width: 17,
        height: 17,
    },

    closeIcon: {
        width: 24,
        height: 24,
        cursor: "pointer",
    },

    betSection: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        borderRadius: 8,
    },

    betItem: {
        flex: '0 0 calc((100% - 50px) / 6)',
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: "transparent",
        border: '1px solid rgba(255, 255, 255, 0.15)',
        padding: '16px 12px',
        borderRadius: 4,
        fontSize: 20,
        fontWeight: 600,
        color: "rgba(255, 255, 255, 0.3)",
        "&:hover": {
            backgroundColor: "rgba(245, 245, 245, 0.05)",
        },
        [theme.breakpoints.down("sm")]: {
            flex: '0 0 calc((100% - 20px) / 3)',
            fontSize: 14,
            height: 35,
        },
    },

    betItemFull: {
        flex: '0 0 100%',
        justifyContent: 'center',
    },

    betItemHalf: {
        flex: '0 0 calc((100% - 10px) / 2)',
        justifyContent: 'center',
    },

    betSectionCollapsed: {
        maxHeight: 88,
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
    },
    showAllToggle: {
        marginTop: 8,
        fontSize: 14,
        color: 'rgba(0,186,108,1)',
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'center',
    },

    goldText: {
        background: 'linear-gradient(180deg, #FF9604 -0.31%, #FFE522 11.9%, #FFFFC1 36.23%, #FFBB1B 65.11%, #E28800 65.12%, #E9A600 88.87%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 700,
    },

    silverText: {
        background: 'linear-gradient(180deg, #C0C0C0 -0.31%, #E5E5E5 11.9%, #FFFFFF 36.23%, #D3D3D3 65.11%, #A8A8A8 65.12%, #B8B8B8 88.87%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 700,
    },

    grayText: {
        color: 'rgba(255, 255, 255, 0.3)',
        fontWeight: 500,
    },

    betItemContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 8,
        width: '100%',
    },

    centeredContent: {
        justifyContent: 'center',
    },

    headerCoinIcon: {
        width: 16,
        height: 16,
    },


    timeSection: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        borderRadius: 8,
        justifyContent: 'space-between',
    },

    timeItem: {
        flex: '1 1 0',
        minWidth: 80,
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        padding: '0 12px',
        borderRadius: 4,
        fontSize: 16,
        fontWeight: 500,
        color: 'rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: "rgba(245, 245, 245, 0.05)",
        },
        [theme.breakpoints.down("sm")]: {
            flex: '0 0 calc((100% - 8px) / 2)',
            '&:last-child': {
                flex: '0 0 100%',
            },
            fontSize: 14,
            height: 35,
        },
    },

    typeSection: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        borderRadius: 8,
    },

    typeItem: {
        flex: '1 1 0',
        minWidth: 100,
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        padding: '0 12px',
        borderRadius: 4,
        fontSize: 16,
        fontWeight: 500,
        color: 'rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: "rgba(245, 245, 245, 0.05)",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
            height: 35,
        },
    },

    gameModeSection: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        borderRadius: 8,
    },

    gameModeItem: {
        flex: '1 1 0',
        minWidth: 100,
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: 4,
        fontSize: 16,
        fontWeight: 500,
        color: 'rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: "rgba(245, 245, 245, 0.05)",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
            height: 35,
        },
    },

    "@keyframes matchItemEnter": {
        "0%": {
            transform: "scale(0.8)",
            opacity: 0,
        },
        "60%": {
            transform: "scale(1.05)",
            opacity: 1,
        },
        "100%": {
            transform: "scale(1)",
            opacity: 1,
        },
    },

    "@keyframes slideDown": {
        "0%": {
            transform: "translateY(-10px)",
            opacity: 0,
        },
        "100%": {
            transform: "translateY(0)",
            opacity: 1,
        },
    },

    matchSectionAnimated: {
        animation: `$slideDown 500ms ease-out`,
    },

    matchSectionWrapper: {
        overflow: 'hidden',
        transition: 'max-height 400ms ease, opacity 400ms ease',
        maxHeight: 0,
        opacity: 0,
    },

    matchSectionWrapperOpen: {
        maxHeight: 200,
        opacity: 1,
    },

    matchSection: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        borderRadius: 8,
    },

    matchItem: {
        flex: '0 0 calc((100% - 40px) / 5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: 4,
        height: 44,
        fontSize: 16,
        fontWeight: 500,
        color: 'rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
        animationName: '$matchItemEnter',
        animationDuration: '0.4s',
        animationFillMode: 'both',
        "&:hover": {
            backgroundColor: "rgba(245, 245, 245, 0.05)",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
            height: 35,
        },
    },

    selected: {
        backgroundColor: "#00BA6C4D !important",
        border: "none !important",
        color: "#fff !important",
    
    },

    whiteText: {
        color: "#fff",
        fontWeight: 700,
    },

    filterSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 8,
        borderRadius: 8,
        border: '1px solid rgba(255, 255, 255, 0.3)',
    },

    buttonBlock: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 10,
        marginTop: 15,
    },

    applyButton: {
        width: "100%",
        height: 48,
        fontSize: 20,
        fontWeight: 700,
        borderRadius: 4,
        border: "none",
        backgroundColor: "rgba(0, 186, 108, 1)",
        color: "rgba(17, 20, 28, 1)",
        [theme.breakpoints.down("sm")]: {
            fontSize: 18,
            textAlign: 'center',
        },
    },
    button: {

    },

    timeIcon: {
        width: 20,
        height: 20,
        marginRight: 8,
    },

    sectionHeader: {
        fontSize: 14,
        fontWeight: 600,
        color: "#fff",
        textTransform: "uppercase",
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 8,
        "&::after": {
            content: '""',
            flexGrow: 1,
            height: 1,
            backgroundColor: "rgba(255,255,255,0.2)",
            marginLeft: 8,
        },
    },


    betToggleMobile: {
        display: 'flex',
        justifyContent: 'center',
    },

    arrowIcon: {
        transition: 'transform 0.3s ease',
        filter: 'brightness(0.6)',
    },

    arrowIconRotated: {
        transform: 'rotate(180deg)',
    }

}));